import styled, {th} from 'quickstart/system'

export const UniversalLink = styled.a`
  ${th(`links.unstyled`)};
`
